<template>
  <div class="outer-wrapper">
    <p v-if="title" class="field-title">
      {{ title }}.<span v-if="titleAddon" class="field-title-addon"> {{ titleAddon }}.</span>
    </p>
    <p 
      v-if="description || total" class="field-description"
      :class="cssClass"
    >
      {{ description }} <strong>{{ total }}</strong>
    </p>
    
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    titleAddon: String,
    description: String,
    name: String,
    total: String,
    cssClass: String,
  },
}
</script>

<style lang="scss" scoped>
.outer-wrapper {
  grid-column: span 3;
  font-size: $font-size-caption;
  p.field-title {
    font-size: 20px;
    line-height: 36px;
    @include font-rule('averta-bold');
    //margin-bottom: 0;
    span {
      color: $bluebell;
      font-size: 20px;
      @include font-rule('averta-bold');
    }
  }
  p.field-description {
    font-size: $font-size-caption;
    line-height: 18px;
    color: $bluebell;
    letter-spacing: 0.33px;
    margin-top: 3px;
    &.dark {
      color: $black;
    }
  }
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    //border-bottom: 1px solid $flax-bloom;
  }
  &.fullborder > div {
    border: 1px solid $blue;
    input {
      margin: 7px !important;
    }
  }
}
</style>
